import React, { useEffect, useState } from 'react';
import * as dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Accordion from 'components/atoms/Accordion/Accordion';
import { Language } from 'language/Language';
import { urls } from '../productLinks';
import { strings } from './strings';
import './_Faq.scss';

const Faq = () => {
  const language = Language();
  const { entitlement } = useSelector((state) => state);
  const [entitlementHasExpired, setEntitlementExpired] = useState(false);

  useEffect(() => {
    const today = new Date();
    if (entitlement) {
      setEntitlementExpired(dayjs().isAfter(dayjs(entitlement.expiration), today));
    }
  }, [entitlement]);

  return (
    <div className='container-main'>
      <h1>{strings[language].title}</h1>
      <Accordion title={strings[language].accordion1.title}>
        <>
          <strong>{strings[language].accordion1.subtitle1}</strong>
          <ul>
            {language === 'japan'
              && (
                <li>{strings[language].accordion1.res5}</li>
              )}
            <li>{strings[language].accordion1.res1}</li>
            <li>{strings[language].accordion1.res3}</li>
            <li>{strings[language].accordion1.res4}</li>
          </ul>
          <strong>{strings[language].accordion1.subtitle2}</strong>
          <ul>
            <li>{strings[language].accordion1.res2}</li>
            <li>{strings[language].accordion1.res3}</li>
            <li>{strings[language].accordion1.res4}</li>
          </ul>
        </>
      </Accordion>
      <Accordion title={strings[language].accordion2.title}>
        <>
          <p>{strings[language].accordion2.subtitle}</p>
          <ul>
            <li>{strings[language].accordion2.li1}</li>
            <li>{strings[language].accordion2.li2}</li>
            <li>{strings[language].accordion2.li3}</li>
            <li>{strings[language].accordion2.li4}</li>
            <li>{strings[language].accordion2.li5}</li>
            <li>{strings[language].accordion2.li6}</li>
            <li>{strings[language].accordion2.li7}</li>
            <li>{strings[language].accordion2.li8}</li>
          </ul>
          <p>{strings[language].accordion2.description}</p>
        </>
      </Accordion>
      {language === 'japan'
        ? (
          <Accordion title={strings[language].accordion3.title}>
            <>
              <ol>
                <li>{strings[language].accordion3.steps[0]}</li>
                <p>{strings[language].accordion3.p1}</p>
                <p>{strings[language].accordion3.p2}</p>
                <li>{strings[language].accordion3.steps[1]}</li>
                <p>{strings[language].accordion3.p3}</p>
                <li>{strings[language].accordion3.steps[2]}</li>
                <p>{strings[language].accordion3.p4}</p>
              </ol>
            </>
          </Accordion>
        )
        : (
          <Accordion title={strings[language].accordion3.title}>
            <>
              <strong>{strings[language].accordion3.steps[0]}</strong>
              <ol>
                <li>{strings[language].accordion3.li1}</li>
                <li>{strings[language].accordion3.li2}</li>
                <li>{strings[language].accordion3.li3}</li>
                <li>{strings[language].accordion3.li4}</li>
              </ol>
              <strong>{strings[language].accordion3.steps[1]}</strong>
              <ol>
                <li>{strings[language].accordion3.li5}</li>
                <li>{strings[language].accordion3.li6}</li>
                <li>{strings[language].accordion3.li7}</li>
              </ol>
              <strong>{strings[language].accordion3.steps[2]}</strong>
              <ol>
                <li>{strings[language].accordion3.li8}</li>
                <li>{strings[language].accordion3.li9}</li>
              </ol>
            </>
          </Accordion>
        )}
      {language === 'japan'
        ? (
          <Accordion title={strings[language].accordion4.title}>
            <>
              <p>{strings[language].accordion4.p1}</p>
              <p>{strings[language].accordion4.p2}</p>
              <p>{strings[language].accordion4.p3}</p>
              <p>{strings[language].accordion4.p4}</p>
            </>
          </Accordion>
        )
        : (
          <Accordion title='How do I set up my environment for 360 WalkMix Creator™?'>
            <>
              <ol>
                <li>To access 360 WalkMix Creator™ settings, click the settings icon.</li>
                <li>Click the Devices tab. Using the drop-down menus select and set the following: Output type, Output device, set the Sample rate to 48000, and set your Output buffer size.</li>
                <li>For Output type and Output device: Because this plugin has object audio rendering processing and can’t render output to the DAW due to bus constraints in DAW, render output should be connected to a DAC system to listen to 360 WalkMix Creator™ mix audio over loudspeakers.</li>
                <li>Depending upon the capabilities of your system, please choose an Output buffer size of 1,024 or greater, keeping in mind that multiples of 512 are preferable. For example, 1024. If you find that the audio stutters during normal operation, please increase your buffer size further.</li>
              </ol>
              <p>Please see your specific DAW manufacturer guidelines for instructions on how to add a plugin.</p>
            </>
          </Accordion>
        )}
      {language === 'japan'
        ? (
          <Accordion title={strings[language].accordion5.title}>
            <>
              <p>{strings[language].accordion5.p1}</p>
              <p>{strings[language].accordion5.p2}</p>
            </>
          </Accordion>
        )
        : (
          <Accordion title='How do I work with objects in 360 WalkMix Creator™?'>
            <>
              <ul>
                <li>You can change the grouping of objects by simply clicking on an object and dragging it into an existing group. You can also move objects between groups via this method.</li>
                <li>To change the color of an object or group, select the group or object you wish to change the color of and click next to “Color” in the properties pane.</li>
                <li>You can click on the object in the 3d view or top-down view and drag it into your desired position.</li>
                <li>You can select the object or group of objects in either of the viewports or via the objects list and click and drag up or down on either the Elevation or Azimuth to increment or decrement the value respectively.</li>
                <li>You can also click in the Track, Elevation, Azimuth, or Gain values, and type the value you would like to adjust. A single click will allow you to type a value, a click and drag will allow you to increment or decrement the value.</li>
                <li>You can change the gain per object of per group by selecting the object or group and clicking and dragging up on the Gain parameter to increment and down to decrement the gain value in the Properties pane.</li>
                <li>Although you can edit the speaker layout in the settings pane, you can toggle displaying your speaker layout in the editing views by clicking the speaker Icon above the viewport</li>
              </ul>
            </>
          </Accordion>
        )}
      <div className='buyNow-container'>
        <div className='buyNow-hero'>
          <h1>{strings[language].buyNow.title}</h1>
          <p>{strings[language].buyNow.hero}</p>
        </div>
        <Link
          to={entitlement && !entitlementHasExpired ? urls.products[language] : urls.checkout[language]}
          className='main-btn buyNow-btn'
        >
          {entitlement && !entitlementHasExpired ? strings[language].buyNow.product : strings[language].buyNow.button}
        </Link>
      </div>
    </div>
  );
};
export default Faq;
